import { Hero } from '@/components/landing/Hero';
import { About } from '@/components/landing/About';
import { ProgramaSemanaSantaSection } from '@/components/landing/ProgramaSemanaSantaSection';
import { CityMapSection } from '@/components/landing/CityMapSection';
import { motion } from 'framer-motion';

const developers = [
  "Alberto Escalona",
  "David Fouces",
  "Jesus Peñas",
  "Juan Miguel Moral",
  "Luis Miguel Pablos",
  "Pablo Martínez",
];

const collaborators = [
    "Alberto Pozo",
    "Luis Espino",
    "Julio Muñoz",
    "Cristina Luna",
];

function getInitials(name: string) {
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

function PersonCard({ name, index }: { name: string; index: number }) {
  return (
    <motion.div
      className="group relative flex flex-col items-center gap-3 rounded-2xl border border-white/8 bg-card/40 p-5 text-center backdrop-blur-sm transition-colors hover:border-primary/30"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
      whileHover={{ y: -4 }}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary to-amber-600 font-headline text-sm font-bold text-primary-foreground shadow-[0_0_15px_rgba(250,204,21,0.3)]">
        {getInitials(name)}
      </div>
      <p className="text-sm font-semibold">{name}</p>
    </motion.div>
  );
}

function TeamSection() {
  return (
    <section className="relative w-full overflow-hidden bg-card/30 py-24 md:py-32">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.35em] text-primary">
            Detrás de Jartiland
          </span>
          <h2 className="mt-3 font-headline text-4xl font-bold md:text-5xl">El Equipo</h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Las personas que han hecho posible Jartiland.
          </p>
        </div>

        <div className="mt-16">
          <h3 className="mb-6 text-center text-xl font-semibold text-foreground/80">Desarrolladores</h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
            {developers.map((name, i) => (
              <PersonCard key={name} name={name} index={i} />
            ))}
          </div>
        </div>

        <div className="mt-12">
          <h3 className="mb-6 text-center text-xl font-semibold text-foreground/80">Colaboradores</h3>
          <div className="mx-auto grid max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
            {collaborators.map((name, i) => (
              <PersonCard key={name} name={name} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}


export default function Home() {
  return (
    <div className="relative">
      <div
        className="parallax fixed inset-0 -z-10 opacity-20"
        style={{ backgroundImage: "url('/images/nazarenostriana.webp')" }}
      />
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-background via-background/95 to-background" />

      <Hero />
      <ProgramaSemanaSantaSection />
      <About />
      <CityMapSection />
      <TeamSection />
    </div>
  );
}
